import { useMemo } from 'react';

const PAGINATION_BREAK = undefined;

const usePaginationRange = ({ totalPageCount, currentPage, maxSiblings }) => {
  const paginationRange = useMemo(() => {
    if (totalPageCount === 1) {
      return [1];
    }

    const leftSibling = Math.max(currentPage - maxSiblings, 1);
    const rightSibling = Math.min(currentPage + maxSiblings, totalPageCount);

    const range = [];
    let previousPage;

    for (let i = 1; i <= totalPageCount; i++) {
      const isFirstOrLastPage = i === 1 || i === totalPageCount;
      const isWithinDisplayableRange = i >= leftSibling && i <= rightSibling;

      if (isFirstOrLastPage || isWithinDisplayableRange) {
        if (previousPage && i !== previousPage + 1) {
          range.push(PAGINATION_BREAK);
        }
        range.push(i);
        previousPage = i;
      }
    }

    return range;
  }, [totalPageCount, currentPage, maxSiblings]);

  return({
    paginationRange
  });
}

export { usePaginationRange, PAGINATION_BREAK };
